import { Col, Row, Text } from 'components';
import mime from 'mime';
import { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

const Preview = styled.div`
  position: relative;
  border: 1px solid #ddd;
  border-radius: 7px;
  background-image: ${(props) => `url(${props.img})`};
  width: 120px;
  height: 120px;
  z-index: 1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const Story = ({ story, media, error }) => {
  const [previews, setPreviews] = useState([]),
    videoInput = useRef(),
    isVideo = mime.getType(media.uri)?.includes('video'),
    dispatch = useDispatch();

  if (!media) return;

  return (
    <Col noFlex>
      <Text marg="24px 16px 5px" b2 med>
        Recent
      </Text>

      <Col>
        <Row gap="21px" start wrapFlex>
          <Col pos="relative">
            {isVideo ? (
              <ReactPlayer style={{ maxWidth: 552 }} controls url={media?.uri} />
            ) : (
              <Row wid="552px" centerAll>
                <img style={{ maxHeight: 360 }} src={media?.uri} />
              </Row>
            )}
          </Col>
        </Row>
      </Col>
    </Col>
  );
};

export default Story;
